/* eslint-disable import/prefer-default-export */
export const fullscreen = state => {
    return state.fullscreen;
};
